import React, { useState } from 'react';
import { Download, FileText } from 'lucide-react';
import { exportToPDF } from '../utils/pdfExport';
import '../styles/PDFExportButton.css';

interface PDFExportButtonProps {
  className?: string;
  variant?: 'primary' | 'secondary' | 'floating';
  filename?: string;
  elementId?: string;
  children?: React.ReactNode;
}

const PDFExportButton: React.FC<PDFExportButtonProps> = ({
  className = '',
  variant = 'primary',
  filename = 'waymining-landing-page',
  elementId = 'landing-page-container',
  children
}) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    setIsExporting(true);
    try {
      const success = await exportToPDF(filename, elementId);
      if (success) {
        console.log('PDF exported successfully');
      } else {
        console.error('Failed to export PDF');
      }
    } catch (error) {
      console.error('Error exporting PDF:', error);
    } finally {
      setIsExporting(false);
    }
  };

  const getButtonClasses = () => {
    const baseClasses = 'pdf-export-button';

    switch (variant) {
      case 'floating':
        return `${baseClasses} floating`;
      case 'secondary':
        return `${baseClasses} secondary`;
      default:
        return `${baseClasses} primary`;
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={isExporting}
      className={`${getButtonClasses()} ${className} ${isExporting ? 'opacity-50 cursor-not-allowed' : ''}`}
      title="Export to PDF"
    >
      {isExporting ? (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          <span>Exporting...</span>
        </>
      ) : (
        <>
          {variant === 'floating' ? <FileText size={20} /> : <Download size={18} />}
          {children || (variant === 'floating' ? 'PDF' : 'Export PDF')}
        </>
      )}
    </button>
  );
};

export default PDFExportButton;